// extracted by mini-css-extract-plugin
module.exports = {"component":"repeater-matrix-type-body_component_3VNZ4"};